import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useHistory } from "react-router-dom";

const DealerDropdown = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRegisterDealer = () => {
    handleClose();
    history.push("/register-dealer");
  };

  const handleDealerOverview = () => {
    handleClose();
    history.push("/dealer-overview");
  };

  return (
    <div>
      <Button
        id="dealer-button"
        aria-controls={open ? "dealer-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        color="inherit"
        endIcon={<ArrowDropDownIcon />}
      >
        Dealer
      </Button>
      <Menu
        id="dealer-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "dealer-button",
        }}
      >
        <MenuItem onClick={handleDealerOverview}>Dealer Overview</MenuItem>
        <MenuItem onClick={handleRegisterDealer}>Register Dealer</MenuItem>
      </Menu>
    </div>
  );
};

export default DealerDropdown;
